import React from 'react'
import Error404 from '../components/error404/error404'

export default function Page404() {
    return (
        <Error404 />
    )
}